export default __webpack_public_path__ + "static/media/user-round.bcd56814.svg";